import styled from "styled-components";
import { FlexColumn } from "../Styles";

export const PlayerControlsContainer = styled(FlexColumn)<{ $isShow: boolean }>`
  position: absolute;
  inset: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  justify-content: end;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-10"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary-disabled"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
`;
